// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-flow__node {
    max-width: 170px;
}

.react-flow__node-body {
    border-radius: 8px;
    color: #171717;
    font-size: 10px;
    min-width: 140px;
    box-sizing: border-box;
    border: 1px solid transparent;
    cursor: pointer;
}

.react-flow__node-inner-body {
    padding: 6px;
    box-sizing: border-box;
}

.react-flow__node-header {
    text-align: center;
    width: 100%;
    position: relative;
    text-align: left;
}

.react-flow__node-header .react-flow__node-label {
    margin-left: 22px;
    margin-right: 5px;
}

.react-flow__node-header .dashicon {
    margin-right: 4px;
    position: absolute;
    left: 2px;
    top: 2px;
}

.react-flow__node-header .node-icon {
    margin-right: 4px;
    position: absolute;
    top: 1px;
    left: 2px;
}

.react-flow__node-description {
    font-size: 8px;
    line-height: 10px;
    color: #0000008a;
    margin-top: 0px;
    margin-left: 16px;
    padding: 0px 6px;
    border-radius: 6px;
    overflow-wrap: break-word;
    max-width: 140px;
    margin-bottom: 6px;
}

.react-flow__node-inner-body.with-description {
    padding-bottom: 4px;
}

.react-flow__node-slug {
    font-size: 8px;
    display: inline-block;
    height: 6px;
    line-height: 6px;
    padding: 2px;
    position: absolute;
    top: 45px;
    left: 27px;
}

.react-flow__handle {
    width: 8px !important;
    height: 8px !important;
    box-sizing: border-box;
}

.react-flow__handle.react-flow__handle-bottom {
    bottom: -4px !important;
}

.react-flow__handle.react-flow__handle-top {
    top: -4px !important;
}

.react-flow__node-top {
    font-size: 8px;
    padding: 0 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid silver;
    position: relative;
    padding-left: 18px;
}

.react-flow__node-top .publishpress-icon {
    margin-right: 4px;
    position: absolute;
    top: 1px;
    left: 8px;
}

.react-flow__node-inserter-popover .components-popover__content {
    width: 350px;
}

.react-flow__node-inserter-popover {
    display: flex;
    flex-direction: column;
    position: relative;
}

.react-flow__node-inserter-popover-content {
    height: 100%;
    overflow-y: auto;
    height: 340px;
}

.react-flow__node-inserter-popover-close {
    cursor: pointer;
    background-color: #000;
    color: #fff;
    display: block;
    width: 100%;
    padding: 6px;
    height: 44px;
}

/* DEFAULT STYLE FOR NODES */

.react-flow__node-genericNode,
.react-flow__node-genericTrigger,
.react-flow__node-unknownNode,
.react-flow__node-genericAction,
.react-flow__node-genericAdvanced,
.react-flow__node-queryAction,
.react-flow__node-debugAction,
.react-flow__handle {
    border-width: 1px;
    border-style: solid;
}

.react-flow__node-inner-body {
    border-bottom-width: 1px;
    border-bottom-style: solid;
}

/* GENERIC NODE */

.react-flow__node-genericNode {
    background-color: #b2b2c9;
    border-color: #b2b2c9;
}

.react-flow__node-genericNode .react-flow__handle {
    background-color: #fff;
    border-color: #b2b2c9;
}

.react-flow__node-genericNode .react-flow__node-top {
    border-color: #b2b2c9;
}

.react-flow__node-genericNode .react-flow__node-slug {
    color: #b2b2c9;
}

.react-flow__node-genericNode .react-flow__node-inner-body {
    border-bottom-color: #b2b2c9;
}

/* TRIGGER */

.react-flow__node-genericTrigger {
    background-color: #dce5df;
    border-color: #b9c0bb;
}

.react-flow__node-genericTrigger .react-flow__handle {
    background-color: #fff;
    border-color: #B594B6;
}

.react-flow__node-genericTrigger  .react-flow__node-slug {
    color: #939895;
}

.react-flow__node-genericTrigger .react-flow__node-top {
    border-color: #b9c0bb;
}

.react-flow__node-genericTrigger .react-flow__node-slug {
    color: #808882;
}

.react-flow__node-genericTrigger .react-flow__node-inner-body {
    border-bottom-color: #b9c0bb;
}

/* GENERIC ACTION */

.react-flow__node-unknownNode {
    background-color: #afafaf;
    border-color: #bbbbbb;
}

.react-flow__node-genericAction {
    background-color: #89bae4;
    border-color: #7199bc;
}

.react-flow__node-unknownNode .react-flow__handle,
.react-flow__node-genericAction .react-flow__handle {
    background-color: #fff;
    border-color: #7199bc;
}

.react-flow__node-unknownNode .react-flow__node-slug,
.react-flow__node-genericAction .react-flow__node-slug {
    color: #8a62be;
}

.react-flow__node-unknownNode .react-flow__node-top,
.react-flow__node-genericAction .react-flow__node-top {
    border-color: #7199bc;
}

.react-flow__node-unknownNode .react-flow__node-slug,
.react-flow__node-genericAction .react-flow__node-slug {
    color: #526e87;
}

.react-flow__node-genericAction .react-flow__node-inner-body {
    border-bottom-color: #7199bc;
}

/* GENERIC ADVANCED */

.react-flow__node-genericAdvanced {
    background-color: #f8ddad;
    border-color: #d3bc94;
}

.react-flow__node-genericAdvanced .react-flow__handle {
    background-color: #fff;
    border-color: #d3bc94;
}

.react-flow__node-genericAdvanced .react-flow__node-slug {
    color: #b19f80;
}

.react-flow__node-genericAdvanced .react-flow__node-top {
    border-color: #d3bc94;
}

.react-flow__node-genericAdvanced .react-flow__node-slug {
    color: #908065;
}

.react-flow__node-genericAdvanced .react-flow__node-inner-body {
    border-bottom-color: #d3bc94;
}

/* QUERY ACTION */

.react-flow__node-queryAction {
    background-color: #d8b6f2;
    border-color: #b891c2;
}

.react-flow__node-queryAction .react-flow__handle {
    background-color: #fff;
    border-color: #b891c2;
}

.react-flow__node-queryAction .react-flow__node-slug {
    color: #9079a1;
}

.react-flow__node-queryAction .react-flow__node-top {
    border-color: #b891c2;
}

.react-flow__node-queryAction .react-flow__node-slug {
    color: rgb(110, 110, 125);
}

.react-flow__node-queryAction .react-flow__node-inner-body {
    border-bottom-color: #b891c2;
}

/* DEBUG ACTION */

.react-flow__node-debugAction {
    background-color: #f0aec6;
    border-color: #cf96ab;
}

.react-flow__node-debugAction .react-flow__handle {
    background-color: #fff;
    border-color: #cf96ab;
}

.react-flow__node-debugAction .react-flow__node-slug {
    color: #916877;
}

.react-flow__node-debugAction .react-flow__node-top {
    border-color: #cf96ab;
}

.react-flow__node-debugAction .react-flow__node-inner-body {
    border-bottom-color: #cf96ab;
}

/* PLACEHOLDER FOR EMPTY FLOW */
.react-flow__node-triggerPlaceholderNode {
    background-color: #fff;
    border: 1px dashed #d2d2d2;
    cursor: pointer;
}

.react-flow__node-triggerPlaceholderNode .react-flow__node-header {
    display: flex;
    align-items: center;
}

.react-flow__node-triggerPlaceholderNode .react-flow__node-header .icon {
    color: #fff;
    background-color: #d2d2d2;
    padding: 2px;
    display: inline-block;
    width: 12px;
    height: 12px;
    box-sizing: border-box;
    position: relative;
    border-radius: 1px;
    margin-right: 6px;
}

.react-flow__node-triggerPlaceholderNode .react-flow__node-header .icon svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
}

.react-flow__node-triggerPlaceholderNode .react-flow__node-header .react-flow__node-label {
    color: #d2d2d2
}

.react-flow__node-triggerPlaceholderNode .react-flow__node-header {
    padding-left: 0;
}

.react-flow__node-triggerPlaceholderNode:hover {
    border: 1px dashed #aeaeae;
}

.react-flow__node-triggerPlaceholderNode:hover .react-flow__node-header .icon {
    background-color: #aeaeae;
}

.react-flow__node-triggerPlaceholderNode:hover .react-flow__node-header .react-flow__node-label {
    color: #aeaeae;
}

.react-flow__node-triggerPlaceholderNode .react-flow__node-inner-body {
    border-bottom: none;
}

/* SELECTED NODES */
.react-flow__node.selected {
    background-color: transparent;
}

.react-flow__node.selected .react-flow__node-body {
    border: 1px dashed #555;
}

.react-flow__node-genericNode .react-flow__node-slug {
    color: #b2b2c9;
}

/* HANDLE AREA */

.react-flow__node-handle-area {
    font-size: 6px;
    background-color: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    display: flex;
    flex-direction: row;
}

.react-flow__node-handle-name {
    padding: 4px 2px 6px 2px;
    text-align: center;
    line-height: 100%;
    flex: 1;
    border-left: 1px solid silver;
}

.react-flow__node-handle-name:first-child {
    border-left: 0;
}

/* Node Content */
.react-flow__node-content {
    font-size: 6px;
    margin-top: 6px;
}

.react-flow__node-content table {
    border-spacing: 0;
    width: 100%;
}

.react-flow__node-content table th {
    text-align: left;
}

.react-flow__node-content table th,
.react-flow__node-content table td {
    padding: 0 6px;
    font-size: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

/* Node Markers */
.react-flow__node-marker-wrapper {
    position: absolute;
    top: -17px;
    right: 0;
    display: flex;
    flex-direction: row;
    gap: 2px;
    justify-content: right;
}

.react-flow__node-error,
.react-flow__node-pro-badge {
    display: flex;
    border-radius: 100%;
    width: 14px;
    height: 14px;
    box-sizing: border-box;
    justify-content: center;
    vertical-align: middle;
}

.react-flow__node-pro-badge {
    background-color: #ffb200;
    color: #000;
}

.react-flow__node-pro-badge .node-icon {
    margin-top: -2px;
}

.react-flow__node-error {
    background-color: #d90f0f;
    color: #fff;
    font-size: 10px;
    text-align: center;
    line-height: 12px;
    font-family: monospace;
    font-weight: 900;
    padding-left: 0px;
}

.react-flow__node-error .node-icon {
    margin-top: 2px;
}

body.workflow-editor.is-free .react-flow__node-handle-name {
    color: #838383;
}

body.workflow-editor.is-free .react-flow__node-handle-name.handle-area-source-output,
body.workflow-editor.is-free .react-flow__node-handle-name.handle-area-source-true {
    color: #000;
}

.react-flow__node-top .node-slug {
    color: #0000008a;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/node-types.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA,4BAA4B;;AAE5B;;;;;;;;IAQI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA,iBAAiB;;AAEjB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,YAAY;;AAEZ;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,mBAAmB;;AAEnB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,qBAAqB;;AAErB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,iBAAiB;;AAEjB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA,iBAAiB;;AAEjB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,+BAA+B;AAC/B;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;;AAEhB;IACI,cAAc;IACd,sBAAsB;IACtB,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,OAAO;IACP,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,cAAc;IACd,oCAAoC;AACxC;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".react-flow__node {\n    max-width: 170px;\n}\n\n.react-flow__node-body {\n    border-radius: 8px;\n    color: #171717;\n    font-size: 10px;\n    min-width: 140px;\n    box-sizing: border-box;\n    border: 1px solid transparent;\n    cursor: pointer;\n}\n\n.react-flow__node-inner-body {\n    padding: 6px;\n    box-sizing: border-box;\n}\n\n.react-flow__node-header {\n    text-align: center;\n    width: 100%;\n    position: relative;\n    text-align: left;\n}\n\n.react-flow__node-header .react-flow__node-label {\n    margin-left: 22px;\n    margin-right: 5px;\n}\n\n.react-flow__node-header .dashicon {\n    margin-right: 4px;\n    position: absolute;\n    left: 2px;\n    top: 2px;\n}\n\n.react-flow__node-header .node-icon {\n    margin-right: 4px;\n    position: absolute;\n    top: 1px;\n    left: 2px;\n}\n\n.react-flow__node-description {\n    font-size: 8px;\n    line-height: 10px;\n    color: #0000008a;\n    margin-top: 0px;\n    margin-left: 16px;\n    padding: 0px 6px;\n    border-radius: 6px;\n    overflow-wrap: break-word;\n    max-width: 140px;\n    margin-bottom: 6px;\n}\n\n.react-flow__node-inner-body.with-description {\n    padding-bottom: 4px;\n}\n\n.react-flow__node-slug {\n    font-size: 8px;\n    display: inline-block;\n    height: 6px;\n    line-height: 6px;\n    padding: 2px;\n    position: absolute;\n    top: 45px;\n    left: 27px;\n}\n\n.react-flow__handle {\n    width: 8px !important;\n    height: 8px !important;\n    box-sizing: border-box;\n}\n\n.react-flow__handle.react-flow__handle-bottom {\n    bottom: -4px !important;\n}\n\n.react-flow__handle.react-flow__handle-top {\n    top: -4px !important;\n}\n\n.react-flow__node-top {\n    font-size: 8px;\n    padding: 0 8px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    border-bottom: 1px solid silver;\n    position: relative;\n    padding-left: 18px;\n}\n\n.react-flow__node-top .publishpress-icon {\n    margin-right: 4px;\n    position: absolute;\n    top: 1px;\n    left: 8px;\n}\n\n.react-flow__node-inserter-popover .components-popover__content {\n    width: 350px;\n}\n\n.react-flow__node-inserter-popover {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.react-flow__node-inserter-popover-content {\n    height: 100%;\n    overflow-y: auto;\n    height: 340px;\n}\n\n.react-flow__node-inserter-popover-close {\n    cursor: pointer;\n    background-color: #000;\n    color: #fff;\n    display: block;\n    width: 100%;\n    padding: 6px;\n    height: 44px;\n}\n\n/* DEFAULT STYLE FOR NODES */\n\n.react-flow__node-genericNode,\n.react-flow__node-genericTrigger,\n.react-flow__node-unknownNode,\n.react-flow__node-genericAction,\n.react-flow__node-genericAdvanced,\n.react-flow__node-queryAction,\n.react-flow__node-debugAction,\n.react-flow__handle {\n    border-width: 1px;\n    border-style: solid;\n}\n\n.react-flow__node-inner-body {\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n}\n\n/* GENERIC NODE */\n\n.react-flow__node-genericNode {\n    background-color: #b2b2c9;\n    border-color: #b2b2c9;\n}\n\n.react-flow__node-genericNode .react-flow__handle {\n    background-color: #fff;\n    border-color: #b2b2c9;\n}\n\n.react-flow__node-genericNode .react-flow__node-top {\n    border-color: #b2b2c9;\n}\n\n.react-flow__node-genericNode .react-flow__node-slug {\n    color: #b2b2c9;\n}\n\n.react-flow__node-genericNode .react-flow__node-inner-body {\n    border-bottom-color: #b2b2c9;\n}\n\n/* TRIGGER */\n\n.react-flow__node-genericTrigger {\n    background-color: #dce5df;\n    border-color: #b9c0bb;\n}\n\n.react-flow__node-genericTrigger .react-flow__handle {\n    background-color: #fff;\n    border-color: #B594B6;\n}\n\n.react-flow__node-genericTrigger  .react-flow__node-slug {\n    color: #939895;\n}\n\n.react-flow__node-genericTrigger .react-flow__node-top {\n    border-color: #b9c0bb;\n}\n\n.react-flow__node-genericTrigger .react-flow__node-slug {\n    color: #808882;\n}\n\n.react-flow__node-genericTrigger .react-flow__node-inner-body {\n    border-bottom-color: #b9c0bb;\n}\n\n/* GENERIC ACTION */\n\n.react-flow__node-unknownNode {\n    background-color: #afafaf;\n    border-color: #bbbbbb;\n}\n\n.react-flow__node-genericAction {\n    background-color: #89bae4;\n    border-color: #7199bc;\n}\n\n.react-flow__node-unknownNode .react-flow__handle,\n.react-flow__node-genericAction .react-flow__handle {\n    background-color: #fff;\n    border-color: #7199bc;\n}\n\n.react-flow__node-unknownNode .react-flow__node-slug,\n.react-flow__node-genericAction .react-flow__node-slug {\n    color: #8a62be;\n}\n\n.react-flow__node-unknownNode .react-flow__node-top,\n.react-flow__node-genericAction .react-flow__node-top {\n    border-color: #7199bc;\n}\n\n.react-flow__node-unknownNode .react-flow__node-slug,\n.react-flow__node-genericAction .react-flow__node-slug {\n    color: #526e87;\n}\n\n.react-flow__node-genericAction .react-flow__node-inner-body {\n    border-bottom-color: #7199bc;\n}\n\n/* GENERIC ADVANCED */\n\n.react-flow__node-genericAdvanced {\n    background-color: #f8ddad;\n    border-color: #d3bc94;\n}\n\n.react-flow__node-genericAdvanced .react-flow__handle {\n    background-color: #fff;\n    border-color: #d3bc94;\n}\n\n.react-flow__node-genericAdvanced .react-flow__node-slug {\n    color: #b19f80;\n}\n\n.react-flow__node-genericAdvanced .react-flow__node-top {\n    border-color: #d3bc94;\n}\n\n.react-flow__node-genericAdvanced .react-flow__node-slug {\n    color: #908065;\n}\n\n.react-flow__node-genericAdvanced .react-flow__node-inner-body {\n    border-bottom-color: #d3bc94;\n}\n\n/* QUERY ACTION */\n\n.react-flow__node-queryAction {\n    background-color: #d8b6f2;\n    border-color: #b891c2;\n}\n\n.react-flow__node-queryAction .react-flow__handle {\n    background-color: #fff;\n    border-color: #b891c2;\n}\n\n.react-flow__node-queryAction .react-flow__node-slug {\n    color: #9079a1;\n}\n\n.react-flow__node-queryAction .react-flow__node-top {\n    border-color: #b891c2;\n}\n\n.react-flow__node-queryAction .react-flow__node-slug {\n    color: rgb(110, 110, 125);\n}\n\n.react-flow__node-queryAction .react-flow__node-inner-body {\n    border-bottom-color: #b891c2;\n}\n\n/* DEBUG ACTION */\n\n.react-flow__node-debugAction {\n    background-color: #f0aec6;\n    border-color: #cf96ab;\n}\n\n.react-flow__node-debugAction .react-flow__handle {\n    background-color: #fff;\n    border-color: #cf96ab;\n}\n\n.react-flow__node-debugAction .react-flow__node-slug {\n    color: #916877;\n}\n\n.react-flow__node-debugAction .react-flow__node-top {\n    border-color: #cf96ab;\n}\n\n.react-flow__node-debugAction .react-flow__node-inner-body {\n    border-bottom-color: #cf96ab;\n}\n\n/* PLACEHOLDER FOR EMPTY FLOW */\n.react-flow__node-triggerPlaceholderNode {\n    background-color: #fff;\n    border: 1px dashed #d2d2d2;\n    cursor: pointer;\n}\n\n.react-flow__node-triggerPlaceholderNode .react-flow__node-header {\n    display: flex;\n    align-items: center;\n}\n\n.react-flow__node-triggerPlaceholderNode .react-flow__node-header .icon {\n    color: #fff;\n    background-color: #d2d2d2;\n    padding: 2px;\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    box-sizing: border-box;\n    position: relative;\n    border-radius: 1px;\n    margin-right: 6px;\n}\n\n.react-flow__node-triggerPlaceholderNode .react-flow__node-header .icon svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 12px;\n    height: 12px;\n}\n\n.react-flow__node-triggerPlaceholderNode .react-flow__node-header .react-flow__node-label {\n    color: #d2d2d2\n}\n\n.react-flow__node-triggerPlaceholderNode .react-flow__node-header {\n    padding-left: 0;\n}\n\n.react-flow__node-triggerPlaceholderNode:hover {\n    border: 1px dashed #aeaeae;\n}\n\n.react-flow__node-triggerPlaceholderNode:hover .react-flow__node-header .icon {\n    background-color: #aeaeae;\n}\n\n.react-flow__node-triggerPlaceholderNode:hover .react-flow__node-header .react-flow__node-label {\n    color: #aeaeae;\n}\n\n.react-flow__node-triggerPlaceholderNode .react-flow__node-inner-body {\n    border-bottom: none;\n}\n\n/* SELECTED NODES */\n.react-flow__node.selected {\n    background-color: transparent;\n}\n\n.react-flow__node.selected .react-flow__node-body {\n    border: 1px dashed #555;\n}\n\n.react-flow__node-genericNode .react-flow__node-slug {\n    color: #b2b2c9;\n}\n\n/* HANDLE AREA */\n\n.react-flow__node-handle-area {\n    font-size: 6px;\n    background-color: #fff;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    display: flex;\n    flex-direction: row;\n}\n\n.react-flow__node-handle-name {\n    padding: 4px 2px 6px 2px;\n    text-align: center;\n    line-height: 100%;\n    flex: 1;\n    border-left: 1px solid silver;\n}\n\n.react-flow__node-handle-name:first-child {\n    border-left: 0;\n}\n\n/* Node Content */\n.react-flow__node-content {\n    font-size: 6px;\n    margin-top: 6px;\n}\n\n.react-flow__node-content table {\n    border-spacing: 0;\n    width: 100%;\n}\n\n.react-flow__node-content table th {\n    text-align: left;\n}\n\n.react-flow__node-content table th,\n.react-flow__node-content table td {\n    padding: 0 6px;\n    font-size: 6px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n/* Node Markers */\n.react-flow__node-marker-wrapper {\n    position: absolute;\n    top: -17px;\n    right: 0;\n    display: flex;\n    flex-direction: row;\n    gap: 2px;\n    justify-content: right;\n}\n\n.react-flow__node-error,\n.react-flow__node-pro-badge {\n    display: flex;\n    border-radius: 100%;\n    width: 14px;\n    height: 14px;\n    box-sizing: border-box;\n    justify-content: center;\n    vertical-align: middle;\n}\n\n.react-flow__node-pro-badge {\n    background-color: #ffb200;\n    color: #000;\n}\n\n.react-flow__node-pro-badge .node-icon {\n    margin-top: -2px;\n}\n\n.react-flow__node-error {\n    background-color: #d90f0f;\n    color: #fff;\n    font-size: 10px;\n    text-align: center;\n    line-height: 12px;\n    font-family: monospace;\n    font-weight: 900;\n    padding-left: 0px;\n}\n\n.react-flow__node-error .node-icon {\n    margin-top: 2px;\n}\n\nbody.workflow-editor.is-free .react-flow__node-handle-name {\n    color: #838383;\n}\n\nbody.workflow-editor.is-free .react-flow__node-handle-name.handle-area-source-output,\nbody.workflow-editor.is-free .react-flow__node-handle-name.handle-area-source-true {\n    color: #000;\n}\n\n.react-flow__node-top .node-slug {\n    color: #0000008a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
